export const ENTITY_PAGE_SIZE = 20;

export function mergeEntityPage(prevItems = [], nextItems = [], append = false) {
  if (!append) return nextItems;
  const seen = new Set(prevItems.map((item) => String(item.id)));
  return [
    ...prevItems,
    ...nextItems.filter((item) => !seen.has(String(item.id))),
  ];
}

export function resolveEntityTotalCount({
  append,
  prevCount,
  nextCount,
  totalCount,
}) {
  if (append && nextCount <= prevCount) return prevCount;
  const parsed = Number(totalCount);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
}

export function canLoadMoreEntities({
  entityType,
  isEditing,
  isLoading,
  isLoadingMore,
  isPendingReset,
  loadedCount,
  totalCount,
}) {
  if (
    !entityType ||
    isEditing ||
    isLoading ||
    isLoadingMore ||
    isPendingReset
  ) {
    return false;
  }
  return loadedCount < totalCount;
}

export function shouldFetchNextPageOnScroll({
  scrollTop,
  clientHeight,
  scrollHeight,
  threshold = 48,
}) {
  return scrollTop + clientHeight >= scrollHeight - threshold;
}
